
// import { useState, useContext, useEffect, useRef } from "react";
// import { CartContext } from "../CartContext";
// import "../shippingForm.css";
// import { Button } from "react-bootstrap";
// import ReCAPTCHA from "react-google-recaptcha";

// export default function ShippingForm({ onCheckout, showLoginModal, login,total }) {
//   const [selectedRateId, setSelectedRateId] = useState(null);
//   const [captchaValid, setCaptchaValid] = useState(false);
//     const [free, setFree] = useState(false);
//   const [showGuestPrompt, setShowGuestPrompt] = useState(false);
//   const [shippingRates, setShippingRates] = useState([]);
//   const [autocomplete, setAutocomplete] = useState(null);
// const [show, setShow]=useState(false)
// const [show2, setShow2]=useState(false)
//   const recaptchaRef = useRef(null);
//   const cart = useContext(CartContext);

//   const [address, setAddress] = useState({
//     name: "",
//     street1: "",
//     street2: "",
//     city: "",
//     state: "",
//     zip: "",
//     country: "US",
//   });
// const addressRef = useRef(address);
// const newCompRef= useRef(null)
// const newCompRef2= useRef(null)
//   const handleAddressChange = (e) => {
//     const sanitizedValue = e.target.value.replace(/[<>{}]/g, ""); // basic sanitization
//     setAddress({ ...address, [e.target.name]: sanitizedValue });
//   };

//   const handleCaptchaChange = (value) => {
//     setCaptchaValid(!!value);
//   };
//   useEffect(()=>{
//     if (total>=200){
//       setFree(true)
//     } 
//   },[total])
//   console.log(total)
// useEffect(() => {
//   addressRef.current = address;
// }, [address]);
// useEffect(()=>{
//   if(show && newCompRef.current){
//     newCompRef.current.scrollIntoView({behavior: 'smooth'});
//   }
// },[show])
// useEffect(()=>{
//   if(show2 && newCompRef2.current){
//     newCompRef2.current.scrollIntoView({behavior: 'smooth'});
//   }
// },[show2])

// useEffect(() => {
//   const input = document.getElementById("street1");
//   if (!window.google || !window.google.maps || !input) return;

//   const ac = new window.google.maps.places.Autocomplete(input, {
//     componentRestrictions: { country: "us" },
//     fields: ["address_components", "geometry"],
//   });

// ac.addListener("place_changed", () => {
//   const place = ac.getPlace();
//   if (!place.address_components) return;

//   // Use the latest address state from ref
//   const updatedAddress = {
//     ...addressRef.current,  // <-- latest address, preserves name
//     street1: "",
//     city: "",
//     state: "",
//     zip: "",
//     country: "US",
//   };

//   for (const component of place.address_components) {
//     const types = component.types;
//     const value = component.long_name;

//     if (types.includes("street_number")) {
//       updatedAddress.street1 = value + " ";
//     }
//     if (types.includes("route")) {
//       updatedAddress.street1 = (updatedAddress.street1 || "") + value;
//     }
//     if (types.includes("locality")) {
//       updatedAddress.city = value;
//     }
//     if (types.includes("administrative_area_level_1")) {
//       updatedAddress.state = value;
//     }
//     if (types.includes("postal_code")) {
//       updatedAddress.zip = value;
//     }
//     if (types.includes("country")) {
//       updatedAddress.country = component.short_name;
//     }
//   }

//   setAddress(updatedAddress);
// });


//   setAutocomplete(ac);
// }, []);


//   const getShippingRates = async (addressTo) => {
//     let totalWeight = 0;
//     cart.items.forEach((item) => {
//       const itemWeight = parseFloat(item.weight || 0);
//       const itemQuantity = parseInt(item.quantity || 1);
//       const lineWeight = itemWeight * itemQuantity;
//       totalWeight += lineWeight;
//     });

//     const addressFrom = {
//       name: "Wear & Wonder Boutique",
//       street1: "14915 38th DR SE",
//       street2: "",
//       city: "Bothell",
//       state: "WA",
//       zip: "98012",
//       country: "US",
//       email: "shop@example.com",
//     };

//     const parcel = {
//       length: "14",
//       width: "14",
//       height: "5",
//       distance_unit: "in",
//       weight: (parseFloat(totalWeight) + 1).toFixed(2),
//       mass_unit: "lb",
//     };

//     const res = await fetch(
//       "https://api-shipping-28612190fdf4.herokuapp.com/shippo",
//       {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ address_from: addressFrom, address_to: addressTo, parcel }),
//       }
//     );

//     const rates = await res.json();
//     return rates || [];
//   };

//   const fetchRates = async () => {
//     if (!validateAddress()) return;

//     if (!captchaValid) {
//       alert("Please verify you're not a robot.");
//       return;
//     }
//     const rates = await getShippingRates(address);
//     setShippingRates(rates);
//     setShow(true)
//   };

//   const selectedRate2 = shippingRates.find(
//     (rate) => rate.object_id === selectedRateId
//   );
// useEffect(()=>{
// if(selectedRate2){
//   setShow2(true)
// }
// },[selectedRate2])
//   const handleCheckout = () => {
//     if (!selectedRate2) return alert("Please select a shipping rate");

//     const user = localStorage.getItem("userEmail");
//     if (user) {
//       onCheckout(address, selectedRate2, user);
//     } else {
//       setShowGuestPrompt(true);
//     }
//   };

//   const proceedAsGuest = () => {
//     setShowGuestPrompt(false);
//     onCheckout(address, selectedRate2, "guest@gmail.com");
//   };

//   const openLogin = () => {
//     setShowGuestPrompt(false);
//     if (typeof showLoginModal === "function") {
//       showLoginModal();
//     } else {
//       alert("Login modal should appear here.");
//     }
//   };

//   const handleRateSelect = (id) => {
//     setSelectedRateId(id);
//   };
//   const validateAddress = () => {
//   const { name, street1, city, state, zip } = address;
//   if (!name || !street1 || !city || !state || !zip) {
//     alert("Please fill in all required fields.");
//     return false;
//   }
//   const zipRegex = /^\d{5}(-\d{4})?$/;
//   if (!zipRegex.test(zip)) {
//     alert("Please enter a valid ZIP code.");
//     return false;
//   }
//   return true;
// };


//   return (
//     <div>
//       <h2>Shipping Address</h2>
//       <input
//         className="input"
//         name="name"
//         placeholder="Name"
//         value={address.name}
//         onChange={handleAddressChange}
//       />
//       <input
//         id="street1"
//         className="input"
//         name="street1"
//         placeholder="Street address"
//         value={address.street1}
//         onChange={handleAddressChange}
//         style={{ position: "relative", zIndex: 1000 }} // ensures suggestions are visible
//       />
//       <input
//         className="input"
//         name="street2"
//         placeholder="Street address line 2"
//         value={address.street2}
//         onChange={handleAddressChange}
//       />
//       <input
//         className="input"
//         name="city"
//         placeholder="City"
//         value={address.city}
//         onChange={handleAddressChange}
//       />
//       <input
//         className="input"
//         name="state"
//         placeholder="State"
//         value={address.state}
//         onChange={handleAddressChange}
//       />
//       <input
//         className="input"
//         name="zip"
//         placeholder="ZIP"
//         value={address.zip}
//         onChange={handleAddressChange}
//       />

// <ReCAPTCHA
//   ref={recaptchaRef}
//   sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY2}
//   onChange={handleCaptchaChange}
//   style={{ marginTop:20,marginBottom: "1rem",borderRadius:20 }}
// />



//       <button className="login-button" onClick={fetchRates}>
//         Get Shipping Rates
//       </button>
// {!free && (
//   <>
//       {shippingRates.length > 0 && show &&(
//         <div  ref={newCompRef} style={{ marginTop: "1rem" }}>
//           <h3>Select a Shipping Option:</h3>
//           {/* {shippingRates.map((rate) => (
//             <label
//               key={rate.object_id}
//               style={{
//                 display: "block",
//                 border: "1px solid #ccc",
//                 borderRadius: "8px",
//                 padding: "1rem",
//                 marginBottom: "1rem",
//                 cursor: "pointer",
//                 backgroundColor:
//                   rate.object_id === selectedRateId ? "#e6f7ff" : "#fff",
//               }}
//             >
//               <input
//                 type="radio"
//                 name="shippingRate"
//                 value={rate.object_id}
//                 onChange={() => handleRateSelect(rate.object_id)}
//                 checked={rate.object_id === selectedRateId}
//                 style={{ marginRight: "10px" }}
//               />
//               <img
//                 src={rate.provider_image_75}
//                 alt={rate.provider}
//                 style={{ verticalAlign: "middle" }}
//               />
//               <div>
//                 <strong>Provider:</strong> {rate.provider}
//               </div>
//               <div>
//                 <strong>Service:</strong> {rate.servicelevel?.name}
//               </div>
//               <div>
//                 <strong>Cost:</strong> $
//                 {(parseFloat(rate.amount) + 3).toFixed(2)}
//               </div>
//               <div>
//                 <strong>Attributes:</strong> {rate.attributes.join(", ")}
//               </div>
//             </label>
//           ))} */}
//           {shippingRates
//   .slice() // make a shallow copy so you don’t mutate original
//   .sort((a, b) => parseFloat(a.amount) - parseFloat(b.amount)) // sort by numeric amount
//   .slice(0, 2) // take the 3 cheapest
//   .map((rate) => (
//     <label
//       key={rate.object_id}
//       style={{
//         display: "block",
//         border: "1px solid #ccc",
//         borderRadius: "8px",
//         padding: "1rem",
//         marginBottom: "1rem",
//         cursor: "pointer",
//         backgroundColor:
//           rate.object_id === selectedRateId ? "#e6f7ff" : "#fff",
//       }}
//     >
//       <input
//         type="radio"
//         name="shippingRate"
//         value={rate.object_id}
//         onChange={() => handleRateSelect(rate.object_id)}
//         checked={rate.object_id === selectedRateId}
//         style={{ marginRight: "10px" }}
//       />
//       <img
//         src={rate.provider_image_75}
//         alt={rate.provider}
//         style={{ verticalAlign: "middle" }}
//       />
//       <div>
//         <strong>Provider:</strong> {rate.provider}
//       </div>
//       <div>
//         <strong>Service:</strong> {rate.servicelevel?.name}
//       </div>
//       <div>
//         <strong>Cost:</strong> ${(parseFloat(rate.amount) + 3).toFixed(2)}
//       </div>
//       <div>
//         <strong>Attributes:</strong> {rate.attributes.join(", ")}
//       </div>
//     </label>
//   ))}

//         </div>
//       )}

//       {selectedRate2 && show2 && (
//         <div
//         ref={newCompRef2} 
//           style={{
//             boxShadow: "#cff0ff 0px 10px 10px -5px",
//             marginTop: "1rem",
//             padding: "1rem",
//             border: "2px dashed rgb(16, 137, 211)",
//             borderRadius: 8,
//           }}
//         >
//           <h4>✅ You selected:</h4>
//           <p>
//             <strong>{selectedRate2.provider}</strong> —{" "}
//             {selectedRate2.servicelevel?.name}
//           </p>
//           <p>
//             <strong>
//               Cost: ${(parseFloat(selectedRate2.amount) + 3).toFixed(2)}
//             </strong>
//           </p>
//           <button className="login-button" onClick={handleCheckout}>
//             Continue to Checkout
//           </button>
//         </div>
//       )}
//       </>
// )}
// {free && (
//   <p>freeeee</p>
// )}


//       {showGuestPrompt && (
//         <div
//           onClick={() => setShowGuestPrompt(false)} // ⬅️ close when clicking overlay
//           style={{
//             backgroundColor: "rgba(0,0,0,0.6)",
//             position: "fixed",
//             top: 0,
//             left: 0,
//             right: 0,
//             bottom: 0,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             zIndex: 1000,
//           }}
//         >
//           <div
//             style={{
//               background: "white",
//               padding: "2rem",
//               borderRadius: "12px",
//               textAlign: "center",
//               width: "90%",
//               maxWidth: "400px",
//             }}
//           >
//             <h3>You're not logged in</h3>
//             {/* <p>Would you like to log in or continue as a guest?</p> */}
//             {/* <Button
//               onClick={async () => {
//                 await login();
//                 setShowGuestPrompt(false);
//                 const user = localStorage.getItem("userEmail");
//                 if (user) {
//                   onCheckout(address, selectedRate2, user);
//                 }
//               }}
//               style={{
//                 backgroundImage:
//                   "linear-gradient(to right, #071d49, #A60065)",
//                 color: "#f5efe3",
//                 borderRadius: 10,
//                 fontWeight: "bold",
//                 height: 40,
//                 border: "none",
//                 width: "100%",
//                 marginBottom: 10,
//                 fontSize: "13px",
//                 padding: "6px 12px",
//                 margin: "0 0 0",
//               }}
//             >
//               Sign in with Google
//             </Button>

//             <button
//               onClick={proceedAsGuest}
//               style={{
//                 margin: "0.5rem",
//                 backgroundColor: "#ccc",
//                 padding: "8px 12px",
//               }}
//             >
//               Continue as Guest
//             </button> */}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }
   
////////////////////////////////////////////////////////

// free shipping on $200+


import { useState, useContext, useEffect, useRef } from "react";
import { CartContext } from "../CartContext";
import "../shippingForm.css";
import ReCAPTCHA from "react-google-recaptcha";

// Firebase utils (must match your ../firebaseUsers exports)
import { collection, getDocs, query, where } from "firebase/firestore";
import { userDb } from "../firebaseUsers";
import { signInWithEmailAndPassword } from "firebase/auth";
import { userAuth } from "../firebaseUsers";

export default function ShippingForm({ onCheckout, showLoginModal, total, login }) {
  const cart = useContext(CartContext);

  // basic UI states
  const [showGuestPrompt, setShowGuestPrompt] = useState(false);
const [isSigningIn, setIsSigningIn] = useState(false);
  // address/captcha/shipping states (kept as before)
  const [address, setAddress] = useState({
    name: "",
    street1: "",
    street2: "",
    city: "",
    state: "",
    zip: "",
    country: "US",
  });
  const addressRef = useRef(address);
  const [captchaValid, setCaptchaValid] = useState(false);
  const recaptchaRef = useRef(null);

  const [free, setFree] = useState(false);
  const [shippingRates, setShippingRates] = useState([]);
  const [selectedRateId, setSelectedRateId] = useState(null);

  const [showRates, setShowRates] = useState(false);
  const [showSelected, setShowSelected] = useState(false);

  const ratesRef = useRef(null);
  const selectedRef = useRef(null);

  // total weight
  const [totalWeight, setTotalWeight] = useState(0);

  // login modal local state (embedded in this component)
  const [showLoginModalLocal, setShowLoginModalLocal] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false); // toggles between Login button and form inside guest prompt
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loginError, setLoginError] = useState("");

  // when user attempts checkout but isn't logged in, we store this to resume after login
  const [pendingCheckout, setPendingCheckout] = useState(false);

  // Keep address ref updated
  useEffect(() => {
    addressRef.current = address;
  }, [address]);

  // scroll to selected block
  useEffect(() => {
    if (showSelected && selectedRef.current) {
      selectedRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [showSelected]);

  // compute total weight whenever cart changes
  useEffect(() => {
    let weight = 0;
    cart.items.forEach((item) => {
      const itemWeight = parseFloat(item.weight || 0);
      const itemQuantity = parseInt(item.quantity || 1);
      weight += itemWeight * itemQuantity;
    });
    setTotalWeight(Number(weight).toFixed(2));
  }, [cart.items]);

  // free-shipping checks (weight first, then price)
  useEffect(() => {
    const numericTotal = parseFloat(String(total).replace(/,/g, "")) || 0;

    if (Number(totalWeight) > 15) {
      // only alert once per detection would be nicer; simple alert per change for now
      alert("Your order may qualify for complimentary shipping. If any fees apply, our team will contact you.");
      setFree(true);
      setShippingRates([]);
      setSelectedRateId(null);
      return;
    }

    if (numericTotal >= 200) {
      setFree(true);
      setShippingRates([]);
      setSelectedRateId(null);
      return;
    }

    setFree(false);
  }, [total, totalWeight]);

  // Google Places Autocomplete (unchanged)
  useEffect(() => {
    const input = document.getElementById("street1");
    if (!window.google || !window.google.maps || !input) return;

    const ac = new window.google.maps.places.Autocomplete(input, {
      componentRestrictions: { country: "us" },
      fields: ["address_components", "geometry"],
    });

    ac.addListener("place_changed", () => {
      const place = ac.getPlace();
      if (!place.address_components) return;

      const updated = {
        ...addressRef.current,
        street1: "",
        city: "",
        state: "",
        zip: "",
        country: "US",
      };

      for (const c of place.address_components) {
        const types = c.types;
        const val = c.long_name;
        if (types.includes("street_number")) updated.street1 = val + " ";
        if (types.includes("route")) updated.street1 += val;
        if (types.includes("locality")) updated.city = val;
        if (types.includes("administrative_area_level_1")) updated.state = val;
        if (types.includes("postal_code")) updated.zip = val;
        if (types.includes("country")) updated.country = c.short_name;
      }

      setAddress(updated);
    });
  }, []);

  // handle inputs
  const handleAddressChange = (e) => {
    const sanitizedValue = e.target.value.replace(/[<>{}]/g, "");
    setAddress({ ...address, [e.target.name]: sanitizedValue });
  };
  const handleCaptchaChange = (value) => setCaptchaValid(!!value);

  // shipping rates fetch — unchanged
  const getShippingRates = async (addressTo) => {
    let totalWeightCalc = 0;
    cart.items.forEach((item) => {
      const itemWeight = parseFloat(item.weight || 0);
      const itemQuantity = parseInt(item.quantity || 1);
      totalWeightCalc += itemWeight * itemQuantity;
    });

    const addressFrom = {
      name: "Wear & Wonder Boutique",
      street1: "14915 38th DR SE",
      city: "Bothell",
      state: "WA",
      zip: "98012",
      country: "US",
      email: "wearandwonderboutique@gmail.com",
    };

    const parcel = {
      length: "14",
      width: "14",
      height: "5",
      distance_unit: "in",
      weight: (totalWeightCalc + 1).toFixed(2),
      mass_unit: "lb",
    };

    const res = await fetch(
      "https://api-shipping-28612190fdf4.herokuapp.com/shippo",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          address_from: addressFrom,
          address_to: addressTo,
          parcel,
        }),
      }
    );

    const rates = await res.json();
    return rates || [];
  };

  const fetchRates = async () => {
    if (!validateAddress()) return;
    if (!captchaValid) return alert("Please verify you're not a robot.");
    const rates = await getShippingRates(address);
    setShippingRates(rates);
    setShowRates(true);
  };

  const selectedRate = shippingRates.find((r) => r.object_id === selectedRateId);

  useEffect(() => {
    if (selectedRate) setShowSelected(true);
  }, [selectedRate]);

  // ---------- LOGIN / AUTH HANDLERS inside this child ----------
  // open local login modal (centered)
  const openLoginModalLocal = () => {
    setLoginError("");
    setShowLoginModalLocal(true);
    setShowLoginForm(true); // show the form (hides plain Login button)
  };
  const closeLoginModalLocal = () => {
    setShowLoginModalLocal(false);
    setShowLoginForm(false);
    setLoginError("");
  };

  // username -> email lookup + firebase signIn
const handleSignInLocal = async () => {
  const cleanUsername = username.trim().replace(/[^\w.@-]/g, "");
  const cleanPassword = password.trim();

  if (!cleanUsername || !cleanPassword) {
    setLoginError("Please enter username and password.");
    return;
  }

  try {
    setIsSigningIn(true); // <-- start loading

    const usersRef = collection(userDb, "users");
    const q = query(usersRef, where("username", "==", cleanUsername));
    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      setLoginError("Username not found.");
      setIsSigningIn(false);
      return;
    }

    const userDoc = querySnapshot.docs[0];
    const email = userDoc.data().email;

    const userCredential = await signInWithEmailAndPassword(
      userAuth,
      email,
      cleanPassword
    );

    // persist and notify app (Nav listens for this)
    localStorage.setItem("userEmail", userCredential.user.email);
    window.dispatchEvent(new Event("userLogin"));

    // close modal and reset
    setShowLoginModalLocal(false);
    setShowLoginForm(false);
    setShowGuestPrompt(false);
    setUsername("");
    setPassword("");
    setLoginError("");

    // if checkout was pending, resume it
    if (pendingCheckout) {
      setPendingCheckout(false);
      if (free) {
        onCheckout(address, { amount: -3, provider: "Free Shipping" }, userCredential.user.email);
      } else {
        if (!selectedRate) {
          alert("Please select a shipping rate to continue checkout.");
          setIsSigningIn(false);
          return;
        }
        onCheckout(address, selectedRate, userCredential.user.email);
      }
    }
  } catch (err) {
    console.error("Login error:", err);
    if (err?.code === "auth/wrong-password") {
      setLoginError("Incorrect password.");
    } else {
      setLoginError("Login failed. Please try again.");
    }
  } finally {
    setIsSigningIn(false); // <-- stop loading
  }
};


  // Google sign-in: use parent's login prop if provided.
  // After calling it, wait for the global 'userLogin' event to resume checkout.
  const handleGoogleSignIn = async () => {
    setLoginError("");
    if (typeof login === "function") {
      try {
        // listen once for userLogin event
        const onUserLogin = () => {
          // resume checkout if pending
          setShowLoginModalLocal(false);
          setShowLoginForm(false);
          setShowGuestPrompt(false);
          window.removeEventListener("userLogin", onUserLogin);

          if (pendingCheckout) {
            setPendingCheckout(false);
            const currentUserEmail = localStorage.getItem("userEmail");
            if (free) {
              onCheckout(address, { amount: -3, provider: "Free Shipping" }, currentUserEmail);
            } else {
              if (!selectedRate) {
                alert("Please select a shipping rate to continue checkout.");
                return;
              }
              onCheckout(address, selectedRate, currentUserEmail);
            }
          }
        };

        window.addEventListener("userLogin", onUserLogin);
        // call parent login (google flow)
        await login();
        // note: login() from parent resolves when Google login flow completes (in your Nav code)
        // if parent login resolves but does not dispatch userLogin, Nav already does that; the event handler above will fire.
      } catch (err) {
        console.error("Google login failed:", err);
        setLoginError("Google login failed. Try again.");
      }
    } else {
      setLoginError("Google sign-in not available.");
    }
  };

  // --------------------------------------------------------------

  // Checkout handler — FORCE login: if not logged in, open local login modal and set pendingCheckout true
  const handleCheckout = () => {
    if (!validateAddress()) return;
    if (!captchaValid) return alert("Please verify you're not a robot.");

    const userEmail = localStorage.getItem("userEmail");

    if (!userEmail) {
      // force login flow
      setPendingCheckout(true);
      setShowGuestPrompt(true); // open guest prompt which includes Login button/form
      // open the login modal directly to reduce clicks:
      openLoginModalLocal();
      return;
    }

    // user is logged in -> proceed
    if (free) {
      onCheckout(address, { amount: -3, provider: "Free Shipping" }, userEmail);
    } else {
      if (!selectedRate) return alert("Please select a shipping rate");
      onCheckout(address, selectedRate, userEmail);
    }
  };

  const handleRateSelect = (id) => setSelectedRateId(id);

  const validateAddress = () => {
    const { name, street1, city, state, zip } = address;
    if (!name || !street1 || !city || !state || !zip) {
      alert("Please fill in all required fields.");
      return false;
    }
    const zipRegex = /^\d{5}(-\d{4})?$/;
    if (!zipRegex.test(zip)) {
      alert("Please enter a valid ZIP code.");
      return false;
    }
    return true;
  };

  return (
    <div style={{maxWidth:500}} >
      <h2>Shipping Address</h2>

      <input className="input" name="name" placeholder="Name" value={address.name} onChange={handleAddressChange} />
      <input id="street1" className="input" name="street1" placeholder="Street address" value={address.street1} onChange={handleAddressChange} style={{ zIndex: 1000 }} />
      <input className="input" name="street2" placeholder="Street address line 2" value={address.street2} onChange={handleAddressChange} />
      <input className="input" name="city" placeholder="City" value={address.city} onChange={handleAddressChange} />
      <input className="input" name="state" placeholder="State" value={address.state} onChange={handleAddressChange} />
      <input className="input" name="zip" placeholder="ZIP" value={address.zip} onChange={handleAddressChange} />

      <ReCAPTCHA ref={recaptchaRef} sitekey={process.env.REACT_APP_CAPTCHA_SITE_KEY2} onChange={handleCaptchaChange} style={{ marginTop: 20, marginBottom: 20 }} />

      {free ? (
        <div style={{ marginTop: 20, padding: 20, border: "2px solid #1089d3", borderRadius: 8, textAlign: "center" }}>
          <img src="https://fonts.gstatic.com/s/e/notoemoji/latest/1f973/512.gif" alt="success" style={{ maxWidth: 50, marginBottom: 12 }} />
          <h3>Shipping is on us!</h3>
          <button className="login-button" onClick={handleCheckout}>Continue to Checkout</button>
        </div>
      ) : (
        <>
          <button className="login-button" onClick={fetchRates}>Get Shipping Rates</button>

          {showRates && shippingRates.length > 0 && (
            <div ref={ratesRef} style={{ marginTop: 20 }}>
              <h3>Select a Shipping Option:</h3>
              {shippingRates
                .sort((a, b) => parseFloat(a.amount) - parseFloat(b.amount))
                .slice(0, 2)
                .map((rate) => (
                  <label key={rate.object_id} style={{ display: "block", border: "1px solid #ccc", borderRadius: 8, padding: 16, marginBottom: 16, cursor: "pointer", backgroundColor: rate.object_id === selectedRateId ? "#e6f7ff" : "#fff" }}>
                    <input type="radio" name="shippingRate" value={rate.object_id} onChange={() => handleRateSelect(rate.object_id)} checked={rate.object_id === selectedRateId} style={{ marginRight: 10 }} />
                    <img src={rate.provider_image_75} alt={rate.provider} style={{ verticalAlign: "middle" }} />
                    <div><strong>Provider:</strong> {rate.provider}</div>
                    <div><strong>Service:</strong> {rate.servicelevel?.name}</div>
                    <div><strong>Cost:</strong> ${(parseFloat(rate.amount)).toFixed(2)}</div>
                     {/* ${(parseFloat(rate.amount + 3)).toFixed(2)} */}
                    <div><strong>Attributes:</strong> {rate.attributes.join(", ")}</div>
                  </label>
                ))}
            </div>
          )}

          {showSelected && selectedRate && (
            <div ref={selectedRef} style={{ marginTop: 20, padding: 16, border: "2px solid #1089d3", borderRadius: 8, boxShadow: "0 10px 10px -5px #cff0ff" }}>
              <h4>✅ You selected:</h4>
              <p><strong>{selectedRate.provider}</strong> — {selectedRate.servicelevel?.name}</p>
              <p><strong>Cost: ${(parseFloat(selectedRate.amount)).toFixed(2)}</strong></p>
              {/* ${(parseFloat(selectedRate.amount + 3)).toFixed(2)} */}
              <button className="login-button" onClick={handleCheckout}>Continue to Checkout</button>
            </div>
          )}
        </>
      )}

      {/* Guest prompt (overlay). Clicking outside closes it; clicking inside does not. */}
      {showGuestPrompt && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
          }}
          onClick={() => {
            // clicking outside content closes prompt
            setShowGuestPrompt(false);
            // if user didn't finish login, cancel pending checkout
            setPendingCheckout(false);
            setShowLoginForm(false);
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()} // prevent overlay click from closing when interacting inside
            style={{
              background: "#fff",
              padding: 24,
              borderRadius: 12,
              textAlign: "center",
              width: "90%",
              maxWidth: 420,
            }}
          >
            <h3>You're not logged in</h3>

 

            {/* Embedded login form (appears when showLoginForm true). */}
            {showLoginForm && (
              <div style={{ marginTop: 8 }}>
                <input
                  type="text"
                  placeholder="Username"
                  style={{ width: "100%", padding: 8, marginBottom: 8, borderRadius: 6, border: "1px solid #ccc" }}
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <input
                  type="password"
                  placeholder="Password"
                  style={{ width: "100%", padding: 8, marginBottom: 10, borderRadius: 6, border: "1px solid #ccc" }}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                />
 <button
  onClick={async () => {
    if (!isSigningIn) await handleSignInLocal();
  }}
  disabled={isSigningIn}
  style={{
    backgroundColor: "#071d49",
    color: "#f5efe3",
    borderRadius: 10,
    fontWeight: "bold",
    height: 40,
    border: "none",
    width: "100%",
    marginBottom: 10,
    fontSize: "13px",
    padding: "6px 12px",
    opacity: isSigningIn ? 0.7 : 1,
    cursor: isSigningIn ? "wait" : "pointer",
  }}
>
  {isSigningIn ? "Signing in..." : "Login"}
</button>

                {loginError && <p style={{ color: "red" }}>{loginError}</p>}

                <button
                  onClick={() => {
                    // Google sign-in handled via parent login prop
                    handleGoogleSignIn();
                  }}
                  style={{
                    backgroundImage: "linear-gradient(to right, #071d49, #A60065)",
                    color: "#f5efe3",
                    borderRadius: 10,
                    fontWeight: "bold",
                    height: 40,
                    border: "none",
                    width: "100%",
                    marginBottom: 10,
                    fontSize: "13px",
                    padding: "6px 12px",
                  }}
                >
                  Sign in with Google
                </button>

                <p style={{ textAlign: "center", margin: "10px 0 0" }}>
                  <a href="/signup" style={{ textDecoration: "none", fontSize: "13px", color: "#071d49" }}>
                    Don’t have an account? Sign up
                  </a>
                </p>

                <div style={{ marginTop: 8, textAlign: "center" }}>
                  <button
                    onClick={() => {
                      // close embedded form and show plain login button again
                      setShowLoginForm(false);
                      setLoginError("");
                    }}
                    style={{
                      backgroundColor: "#eee",
                      border: "none",
                      padding: "6px 12px",
                      borderRadius: 6,
                    }}
                  >
                    Back
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
